import React, { useState, useContext } from 'react';
import { AuthContext } from './AuthProvider';
import { useNavigate } from 'react-router-dom';

function RegistrationForm(props) {
    const [username, setUsername] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const {register} = useContext(AuthContext);
    const navigate = useNavigate();
  
    const handleSubmit = (e) => {
      e.preventDefault();
      // Handle registration logic, e.g., send data to API
      register(username, email, password);
      navigate('/verify-registration');
    
      /*
      if (props.parentIsLogin == true) {
        throw new Error('isLogin must be set to false to be in registration')
      }
      localStorage.setItem(email, JSON.stringify({ 
        username: username, email: email, password:password 
         }));
      props.parentSetIsLogin(true);
      console.log('Registration submitted:', { username, email, password });*/
    };
  
    return (
      <form onSubmit={handleSubmit}>
        Register
        <div>
        <input
          type="text"
          placeholder="Username"
          value={username}
          className="text-box-style"
          onChange={(e) => setUsername(e.target.value)}
        />
        </div>
        <div>
        <input
          type="email"
          placeholder="Email"
          value={email}
          className="text-box-style"
          onChange={(e) => setEmail(e.target.value)}
        />
        </div>
        <div>
        <input
          type="password"
          placeholder="Password"
          value={password}
          className="text-box-style"
          onChange={(e) => setPassword(e.target.value)}
        />
        </div>
        <button type="submit">Register</button>
      </form>
    );
  }

  export default RegistrationForm;